import React, { useEffect, useState } from "react";
import cancelIcon from "../assets/images/cancel-icon.png";
import successIcon from "../assets/images/success-icon.gif";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const OrderDetails = () => {
  const { user, token } = useSelector((state) => state.auth);

  const { id } = useParams();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const [orderData, setOrderData] = useState({});
  const [addressData, setAddressData] = useState({});
  const [orderStatus, setOrderStatus] = useState([]);
  const [trackingDetails, setTrackingDetails] = useState(null);
  const [isTrackingLoading, setIsTrackingLoading] = useState(false);

  useEffect(() => {
    fetchOrderViewDetails();
    window.scrollTo(0, 0);
    // Ensure loader shows for at least 0.4 seconds
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [id]);

  const [formData, setFormData] = useState({
    reason: "",
    details: "",
    payment: "credit-card",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateCancelOrder = () => {
    const { reason, details } = formData;
    if (!reason.trim()) {
      toast.error("Please select a valid reason");
      return false;
    }
    // if (!details.trim()) {
    //     toast.error('Please Enter a details')
    //     return false;
    // }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateCancelOrder()) {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/orders/${id}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              reason: formData?.reason,
              details: formData?.details,
            }),
          }
        );
        const orderListData = await res.json();
        if (orderListData.success) {
          const registerModalEl = document.getElementById("cancel-order");
          const registerInstance =
            window.bootstrap.Modal.getInstance(registerModalEl);
          registerInstance.hide();
          const otpModalEl = document.querySelector("#cancel-request");
          const otpModal = new window.bootstrap.Modal(otpModalEl);
          otpModal.show();
          setFormData({
            reason: "",
            details: "",
            payment: "credit-card",
          });
          fetchOrderViewDetails();
        }
      } catch (error) {
        // console.log("error fetch my order", error);
      }
    }
  };

  const fetchOrderViewDetails = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders/view/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      // console.log("data in order details", data.responseObject);
      setOrderData(data.responseObject);
      // console.log("order data", orderData);
      setOrderList(data.responseObject.products);
      setAddressData(data.responseObject.shippingAddress);
      setOrderStatus(data.responseObject.order_status);
      if (data.responseObject?.awbNumber) {
        fetchTrackingDetails(data.responseObject.awbNumber);
      }
    } catch (error) {
      // console.log("error fetch my order", error);
    }
  };

  const fetchTrackingDetails = async (awbNumber) => {
    try {
      setIsTrackingLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/shiprocket/track/${awbNumber}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        setTrackingDetails(data.responseObject);
      }
    } catch (error) {
      // console.error("Error fetching tracking:", error);
    } finally {
      setIsTrackingLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // First, create a helper function to determine which steps should be active
  const getTrackingSteps = (status) => {
    const steps = [
      { key: "Ordered", icon: "fa-map-marker-alt", active: true },
      { key: "Packed", icon: "fa-map-marker-alt", active: false },
      { key: "Dispatched", icon: "fa-map-marker-alt", active: false },
      { key: "Shipped", icon: "fa-map-marker-alt", active: false },
      { key: "Intransit", icon: "fa-map-marker-alt", active: false },
      { key: "Delivered", icon: "fa-map-marker-alt", active: false },
    ];

    // Define the order of statuses
    const statusOrder = {
      Pending: 0, // Added Pending status
      Ordered: 0,
      Packed: 1,
      Dispatched: 2,
      Shipped: 3,
      Intransit: 4,
      Delivered: 5,
    };

    // Get the index of current status
    // const currentStatusIndex = statusOrder[status] || -1;
    const currentStatusIndex =
      statusOrder[status] !== undefined ? statusOrder[status] : 0;
    // Mark all steps up to current status as active
    return steps.map((step, index) => ({
      ...step,
      active: index <= currentStatusIndex,
    }));
  };

  const calculateTotal = () => {
    // if (!isLoggedIn) {
    //     // For non-logged in users
    //     const localCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    //     return localCartItems.reduce((total, item) => {
    //         const basePrice = item?.inPrice * item.quantity;
    //         const gstPercentage = item.category_id?.C_GST || 0;
    //         const sgstPercentage = item.category_id?.S_GST || 0;
    //         const gstAmount = (basePrice * (gstPercentage + sgstPercentage)) / 100;
    //         return total + basePrice + gstAmount;
    //     }, 0);
    // }
    // For logged in users
    return orderList.reduce((total, item) => {
      const basePrice = item?.price * item?.quantity;
      return total + basePrice;
    }, 0);
  };
  const calculateGST = () => {
    const subtotal = parseFloat(calculateTotal());
    let totalCGST = 0;
    let totalSGST = 0;

    orderList.forEach((item) => {
      const basePrice = item?.price * item.quantity;
      const cgstPercentage = item.product_id?.category_id?.C_GST || 0;
      const sgstPercentage = item.product_id?.category_id?.S_GST || 0;

      totalCGST += (basePrice * cgstPercentage) / 100;
      totalSGST += (basePrice * sgstPercentage) / 100;
    });

    return {
      cgst: totalCGST,
      sgst: totalSGST,
      total: totalCGST + totalSGST,
    };
  };
  const calculateFinalPrice = () => {
    // const subtotal = parseFloat(calculateTotal());
    // if (orderData?.couponDetails?.discount > 0) {
    //     const discountAmount = (subtotal * orderData?.couponDetails?.discount) / 100;
    //     return (subtotal - discountAmount);
    // }
    // return subtotal;
    const subtotal = parseFloat(calculateTotal());
    // console.log(subtotal)
    const { total: gstAmount } = calculateGST();
    const totalWithGST = subtotal + parseFloat(gstAmount);
    // console.log(discount)
    if (orderData?.couponDetails?.discount > 0) {
      // const discountAmount = (totalWithGST * discount) / 100 ;
      const discountAmount = parseFloat(
        (calculateTotal() * orderData?.couponDetails?.discount) / 100
      );
      return totalWithGST - discountAmount;
      // return (totalWithGST);
    } else {
      return totalWithGST;
    }
  };

  if (isPageLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  return (
    <>
      {/* Banner Section */}
      <section className="bg-light pt-4" style={{ marginTop: "120px" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-3 mb-md-0">
              <h3 className="mb-0">Order Details</h3>
              <p className="text-muted mb-0">Order ID: {orderData?._id}</p>
            </div>
            <div className="col-md-6 text-md-end">
              <Link
                to={`/invoice/${orderData?._id}`}
                target="_blank"
                className="btn btn-primary"
              >
                <i className="fas fa-download me-2"></i>Download Invoice
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          {/* Order Status Card */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
                <div className="mb-3 mb-md-0">
                  <h6 className="text-muted mb-1">Order Placed</h6>
                  <p className="mb-0 fw-bold">
                    {new Date(orderData?.createdAt).toLocaleDateString()} {" "}
                    {new Date(orderData?.createdAt).toLocaleTimeString()}
                  </p>
                </div>
                <div className="mb-3 mb-md-0">
                  <h6 className="text-muted mb-1">Payment Status</h6>
                  <span
                    className={`p-2 rounded badge text-white bg-${
                      orderData?.paymentStatus === "pending"
                        ? "warning"
                        : orderData?.paymentStatus === "completed"
                        ? "success"
                        : orderData?.paymentStatus === "failed"
                        ? "danger"
                        : orderData?.paymentStatus === "refunded"
                        ? "info"
                        : "secondary"
                    }`}
                  >
                    {orderData?.paymentStatus}
                  </span>
                </div>
                <div className="text-md-end">
                  <h6 className="text-muted mb-1">Status</h6>
                  <span
                    className={`p-2 rounded badge text-white bg-${
                      orderData?.status === "Cancelled" ? "danger" : "success"
                    }`}
                  >
                    {orderData?.status}
                  </span>
                </div>
              </div>

              {/* Order Progress Bar */}
              {orderData?.status !== "Cancelled" && (
                <div className="px-3 py-4">
                  <div className="position-relative tracking-steps">
                    
                    {/* Steps */}
                    <div className="d-flex justify-content-between position-relative flex-wrap" style={{ zIndex: "1" }}>
                      {getTrackingSteps(orderData?.status).map((step, index) => (
                        <div
                          key={index}
                          className="tracking-step text-center mb-3"
                        >
                          <div
                            className={`tracking-icon d-flex align-items-center justify-content-center rounded-circle mx-auto
                            ${step.active ? "bg-light-success border border-success" : "bg-white border"}`}
                            style={step.active ? {backgroundColor: "#a0d6ad"} : {}}
                          >
                            <i className={`fas fa-map-marker-alt ${step.active ? "text-success" : "text-muted"}`}></i>
                          </div>
                          <span className={`mt-2 d-block tracking-label ${step.active ? "text-success fw-bold" : "text-muted"}`}>
                            {step.key}
                          </span>
                          {step.active && (
                            <small className="text-muted d-block mt-1">
                              {formatDate(orderData?.status_change_date)}
                            </small>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Tracking Details */}
              {trackingDetails && (
                <div className="mt-4">
                  <h6 className="mb-3">Tracking Updates</h6>
                  <div className="timeline-tracking">
                    {trackingDetails.tracking_data?.shipment_track_activities?.map((update, index) => (
                      <div key={index} className="timeline-item mb-3">
                        <div className="timeline-content p-3 border rounded bg-light">
                          <div className="d-flex flex-column flex-md-row justify-content-between mb-2">
                            <strong className="mb-1 mb-md-0">{update.activity}</strong>
                            <small className="text-muted">
                              {new Date(update.date).toLocaleString()}
                            </small>
                          </div>
                          {update.location && (
                            <small className="text-muted d-block">
                              <i className="fas fa-map-marker-alt me-1"></i>
                              {update.location}
                            </small>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <style>
            {`
              /* Responsive styles for tracking steps */
              .tracking-steps {
                overflow-x: auto;
                padding: 1rem 0;
                margin: 0 -15px;
              }
              
              .tracking-step {
                flex: 1;
                min-width: 120px;
                padding: 0 15px;
              }
              
              .tracking-icon {
                width: 40px;
                height: 40px;
                transition: all 0.3s ease;
              }
              
              .tracking-label {
                font-size: 0.875rem;
                white-space: nowrap;
              }
              
              /* Timeline styles */
              .timeline-tracking {
                position: relative;
                padding-left: 20px;
              }
              
              .timeline-item {
                position: relative;
              }
              
              .timeline-item::before {
                content: '';
                position: absolute;
                left: -20px;
                top: 0;
                bottom: 0;
                width: 2px;
                background-color: #e9ecef;
              }
              
              .timeline-item::after {
                content: '';
                position: absolute;
                left: -24px;
                top: 10px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #3c3260;
              }
              
              .timeline-content {
                margin-left: 15px;
                border-radius: 8px;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
              }
              
              @media (max-width: 768px) {
                .tracking-steps {
                  overflow-x: auto;
                  -webkit-overflow-scrolling: touch;
                }
                
                .tracking-step {
                  min-width: 100px;
                }
                
                .tracking-icon {
                  width: 35px;
                  height: 35px;
                  font-size: 0.875rem;
                }
                
                .tracking-label {
                  font-size: 0.75rem;
                }
                
                .timeline-content {
                  margin-left: 10px;
                }
                
                .timeline-item::before {
                  left: -15px;
                }
                
                .timeline-item::after {
                  left: -19px;
                  width: 8px;
                  height: 8px;
                }
              }
              
              @media (max-width: 576px) {
                .tracking-step {
                  min-width: 80px;
                }
                
                .tracking-icon {
                  width: 30px;
                  height: 30px;
                  font-size: 0.75rem;
                }
              }
              
              /* Add smooth transitions */
              .tracking-icon, .tracking-label {
                transition: all 0.3s ease;
              }
              
              .tracking-icon.bg-success {
                transform: scale(1.1);
              }
              
              /* Improve timeline visibility */
              .timeline-tracking {
                background: linear-gradient(to bottom, transparent 0%, #fff 100%);
                padding: 20px;
                border-radius: 8px;
              }
              
              .timeline-content:hover {
                transform: translateX(5px);
                transition: transform 0.3s ease;
              }
              
              /* Additional responsive styles */
              .product-item {
                display: flex;
                flex-direction: column;
              }
              
              @media (min-width: 576px) {
                .product-item {
                  flex-direction: row;
                }
              }
              
              .product-image {
                width: 100%;
                max-width: 100px;
                height: 100px;
                margin-bottom: 15px;
              }
              
              @media (min-width: 576px) {
                .product-image {
                  margin-bottom: 0;
                  margin-right: 15px;
                }
              }
              
              .product-details {
                flex-grow: 1;
              }
              
              .product-price {
                text-align: left;
                margin-top: 10px;
              }
              
              @media (min-width: 576px) {
                .product-price {
                  text-align: right;
                  margin-top: 0;
                }
              }
              
              /* Timeline for tracking */
              .timeline {
                position: relative;
                padding-left: 20px;
                margin-left: 10px;
              }
              
              .timeline-item {
                position: relative;
                padding-bottom: 20px;
                padding-left: 20px;
              }
              
              .timeline-marker {
                position: absolute;
                top: 5px;
                left: -5px;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #3c3260;
                z-index: 1;
              }
              
              .timeline-item:not(:last-child)::before {
                content: '';
                position: absolute;
                top: 10px;
                left: 0;
                height: 100%;
                width: 2px;
                background-color: #e9ecef;
              }
              
              .timeline-content {
                background-color: #f8f9fa;
                padding: 15px;
                border-radius: 8px;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                margin-bottom: 5px;
              }
              
              .activity-text {
                word-break: break-word;
              }
              
              /* Responsive order summary */
              @media (max-width: 991px) {
                .order-summary-sidebar {
                  margin-top: 30px;
                }
              }
              
              /* Responsive tracking details */
              .tracking-info .row {
                margin-bottom: 15px;
              }
              
              @media (max-width: 767px) {
                .tracking-info .col-md-4 {
                  text-align: left !important;
                  margin-bottom: 10px;
                }
                
                .tracking-info .col-md-4:last-child {
                  margin-bottom: 0;
                }
              }
            `}
          </style>

          <div className="row">
            {/* Products List */}
            <div className="col-lg-8">
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-header bg-white">
                  <h5 className="mb-0">Ordered Items</h5>
                </div>
                <div className="card-body p-0">
                  {orderData?.products?.map((item) => (
                    <div key={item._id} className="p-3 border-bottom">
                      <div className="product-item">
                        <div className="product-image">
                          <img
                            src={item.productId.productImages[0]}
                            alt={item.productId.productName}
                            className="img-fluid rounded object-fit-cover"
                            style={{ width: "100%", height: "100%" }}
                          />
                        </div>
                        <div className="product-details">
                          <h6 className="mb-1">{item.productId.productName}</h6>
                          <p className="mb-1 text-muted">
                            Weight: {item.weightId.weightInGrams}g | Qty: {" "}
                            {item.quantity}
                          </p>
                          <div className="d-flex align-items-center gap-2 mb-2">
                            <del className="text-muted">
                              ₹{item.price?.toFixed(2)}
                            </del>
                            <span className="fw-bold">
                              ₹{item.discountedPrice?.toFixed(2)}
                            </span>
                            <span className="p-2 rounded badge text-white bg-success">
                              {item.productId.discount_percentage?.toFixed(2)}%
                              OFF
                            </span>
                          </div>
                          <div className="small text-muted">
                            {orderData?.shippingAddress?.state ===
                            "Maharashtra" ? (
                              <>
                                <span className="me-2">
                                  CGST: {item.cgst?.toFixed(2)}
                                </span>
                                <span className="mx-2">
                                  SGST: {item.sgst?.toFixed(2)}
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="me-2">
                                  IGST: {item.igst?.toFixed(2)}
                                </span>
                              </>
                            )}
                            <span className="ms-2">
                              Total Tax: {item.totalTax?.toFixed(2)}
                            </span>
                          </div>
                        </div>
                        <div className="product-price">
                          <p className="mb-1 fw-bold">
                            Total: ₹{item.discountedTotalPrice?.toFixed(2)}
                          </p>
                          <p className="mb-0 text-muted small">
                            (Inc. tax: ₹
                            {(item.totalTax).toFixed(2)}
                            )
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Order Summary Sidebar */}
            <div className="col-lg-4 order-summary-sidebar">
              {/* Delivery Address */}
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-header bg-white">
                  <h5 className="mb-0">Delivery Address</h5>
                </div>
                <div className="card-body">
                  <p className="mb-0">
                    {orderData?.shippingAddress?.street}
                    <br />
                    {orderData?.shippingAddress?.city},{" "}
                    {orderData?.shippingAddress?.state}
                    <br />
                    {orderData?.shippingAddress?.postalCode},{" "}
                    {orderData?.shippingAddress?.country}
                  </p>
                </div>
              </div>

              {/* Price Details */}
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-header bg-white">
                  <h5 className="mb-0">Price Details</h5>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Total MRP</span>
                    <span>₹{Number(orderData?.totalAmount)?.toFixed(2)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Product Discount</span>
                    <span className="text-success">
                      -₹
                      {(
                        orderData.totalAmount - orderData.discountedAmount
                      ).toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Delivery Charges</span>
                    <span className="text-success">
                      ₹{orderData?.deliveryCharges}
                    </span>
                  </div>
                  {orderData?.coupon && (
                    <div className="d-flex justify-content-between mb-2">
                      <span>Coupon ({orderData?.coupon?.coupenCode})</span>
                      <span className="text-success">
                        -₹
                        {(
                          (orderData.discountedAmount *
                            orderData?.coupon?.discount) /
                          100
                        ).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {orderData?.shippingAddress?.state === "Maharashtra" ? (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <span>CGST</span>
                        <span>₹{Number(orderData?.totalCGST?.toFixed(2))}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>SGST</span>
                        <span>₹{Number(orderData?.totalSGST?.toFixed(2))}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <span>IGST</span>
                        <span>₹{Number(orderData?.totalIGST?.toFixed(2))}</span>
                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2">
                    <span>Final Amount</span>
                    <span>₹{Number(orderData?.finalAmount?.toFixed(2))}</span>
                  </div>
                </div>
              </div>

              {/* Cancel Order Button */}
              {(orderData?.status === "pending" ||
                orderData?.status === "processed" ||
                orderData?.status === "shipped") && (
                <button
                  className="btn btn-danger w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#cancel-order"
                >
                  <i className="fas fa-times-circle me-2"></i>
                  Cancel Order
                </button>
              )}
            </div>
          </div>

          {orderData?.awbNumber && (
            <div className="mt-4">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white d-flex justify-content-between align-items-center flex-wrap">
                  <h5 className="mb-0 mb-2 mb-md-0">Shipment Tracking</h5>
                  <div>
                    {!isTrackingLoading ? (
                      <button 
                        className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                        onClick={() => fetchTrackingDetails(orderData.awbNumber)}
                      >
                        <i className="fas fa-sync-alt"></i>
                        Refresh Tracking
                      </button>
                    ) : (
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
                    <div className="mb-2 mb-md-0">
                      <span className="text-muted">AWB Number:</span>
                      <h6 className="mb-0">{orderData.awbNumber}</h6>
                    </div>
                    <div className="text-md-end">
                      <span className="text-muted">Courier:</span>
                      <h6 className="mb-0">{orderData.courier}</h6>
                    </div>
                  </div>

                  {trackingDetails && (
                    <div>
                      <div className="tracking-status mb-4">
                        {/* Handle both response formats */}
                        {(() => {
                          const trackData = trackingDetails.responseObject?.tracking_data || 
                                          Object.values(trackingDetails)[0]?.tracking_data;
                          
                          if (!trackData?.shipment_track?.[0]) {
                            return (
                              <div className="text-center py-4">
                                <i className="fas fa-exclamation-circle fa-3x text-warning mb-3"></i>
                                <p className="text-muted">No tracking information available at the moment</p>
                              </div>
                            );
                          }

                          const currentTrack = trackData.shipment_track[0];
                          
                          return (
                            <>
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                  <span className={`badge ${
                                    currentTrack.current_status === 'Delivered' ? 'bg-success' :
                                    currentTrack.current_status === 'In Transit' ? 'bg-info' :
                                    currentTrack.current_status === 'Cancellation Requested' ? 'bg-danger' :
                                    'bg-warning'
                                  } p-2`}>
                                    {currentTrack.current_status}
                                  </span>
                                </div>
                                {trackData.track_url && (
                                  <a 
                                    href={trackData.track_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    <i className="fas fa-external-link-alt me-1"></i>
                                    Track on Shiprocket
                                  </a>
                                )}
                              </div>

                              <div className="tracking-info">
                                <div className="row mb-3">
                                  <div className="col-md-4">
                                    <small className="text-muted d-block">From</small>
                                    <strong>{currentTrack.origin || 'N/A'}</strong>
                                  </div>
                                  <div className="col-md-4 text-center">
                                    <small className="text-muted d-block">Weight</small>
                                    <strong>{currentTrack.weight || '0'} kg</strong>
                                  </div>
                                  <div className="col-md-4 text-end">
                                    <small className="text-muted d-block">To</small>
                                    <strong>{currentTrack.destination || 'N/A'}</strong>
                                  </div>
                                </div>

                                {currentTrack.edd && (
                                  <div className="text-center mt-3">
                                    <small className="text-muted d-block">Expected Delivery Date</small>
                                    <strong>{new Date(currentTrack.edd).toLocaleDateString()}</strong>
                                  </div>
                                )}
                              </div>

                              {trackData.shipment_track_activities && trackData.shipment_track_activities.length > 0 && (
                                <div className="tracking-timeline mt-4">
                                  <h6 className="mb-3">Tracking Updates</h6>
                                  <div className="timeline">
                                    {trackData.shipment_track_activities.map((activity, idx) => (
                                      <div key={idx} className="timeline-item">
                                        <div className="timeline-marker"></div>
                                        <div className="timeline-content">
                                          <div className="d-flex justify-content-between mb-1">
                                            <strong className="activity-text">{activity.activity}</strong>
                                            <small className="text-muted">
                                              {new Date(activity.date).toLocaleString()}
                                            </small>
                                          </div>
                                          {activity.location && activity.location !== "NA" && (
                                            <small className="text-muted">
                                              <i className="fas fa-map-marker-alt me-1"></i>
                                              {activity.location}
                                            </small>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  )}

                  {!trackingDetails && !isTrackingLoading && (
                    <div className="text-center py-4">
                      <i className="fas fa-truck fa-3x text-muted mb-3 d-block"></i>
                      <p className="text-muted">Click the refresh button to get latest tracking updates</p>
                    </div>
                  )}

                  {isTrackingLoading && (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="text-muted">Fetching latest tracking updates...</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* cancel-order-start */}
      <div
        className="modal fade cancel-modal"
        id="cancel-order"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Cancel Order
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <img src={cancelIcon} className="img-90" alt="cancelIcon" />
              </div>
              <div className="text-center mt-3 mb-3 text-muted fz-14 fw-bold">
                <p className="text-center text-muted">
                  <strong>Important:</strong> If you cancel your order within{" "}
                  <strong>4 hours</strong> of placing it, you will receive a{" "}
                  <strong>full refund</strong>.
                </p>
                <p className="text-center text-muted">
                  If you cancel your order after <strong>4 hours</strong>, a{" "}
                  <strong>partial refund</strong> will be issued.
                </p>
              </div>

              <form action="" onSubmit={handleSubmit}>
                <div className="custom-frm-bx">
                  <label htmlFor="">Reason for Cancellation</label>
                  <select
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    id=""
                    className="form-select"
                  >
                    <option value="">Select Reason</option>
                    <option value="Order taking longer than expected">
                      Order taking longer than expected
                    </option>
                    <option value="I changed my mind">
                      {" "}
                      I changed my mind{" "}
                    </option>
                    <option value="My Reason is not listed">
                      My Reason is not listed
                    </option>
                  </select>
                </div>
                <div className="custom-frm-bx">
                  <label htmlFor="">Write Details</label>
                  <textarea
                    name="details"
                    value={formData.details}
                    onChange={handleChange}
                    className="form-control height-100"
                    // defaultValue={""}
                  />
                </div>
                <div>
                  <p className="text-dark text-capitalize">
                    {" "}
                    <strong>Cancellation Note : </strong>refund will be process
                    in 5-6 working days to your original mode of payment
                  </p>
                  <button
                    type="submit"
                    className="thm-btn w-100 text-center danger"
                  >
                    {" "}
                    Proceed{" "}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* cancel-order-end */}
      {/* order-cancel-success-start */}
      <div
        className="modal fade cancel-modal"
        id="cancel-request"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={successIcon} alt="successicon" />
              <p className="text-center text-success fz-20 fw-600 mb-3">
                Cancel Request submitted Successfully
              </p>
              <button className="thm-btn" data-bs-dismiss="modal">
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* order-cancel-success-end */}
    </>
  );
};

export default OrderDetails;
